import reframe from 'reframe.js/dist/reframe.es.js';

export const responsiveEmbeds = () => {
  reframe('.wp-block-embed iframe');
};
